"use strict";
var DojoCart = {
  items: [],
  total: 0,
  init: function(){ this.fetchCart(); },
  fetchCart: function(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      DojoCart.items = cart.items || [];
      DojoCart.total = cart.total_price || 0;
      DojoCart.render(cart);
    });
  },
  formatMoney: function(cents, currency){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency: currency || 'USD'}).format((cents || 0) / 100);
    } catch(e){
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  },
  render: function(cart){
    window.dojoProductCurrency = cart.currency || window.dojoProductCurrency || 'USD';
    var count = document.getElementById('cart-count');
    if (count){ count.textContent = cart.item_count || 0; count.hidden = !cart.item_count; }

    var drawerCount = document.getElementById('drawer-item-count');
    if (drawerCount) drawerCount.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    var list = document.getElementById('cart-items-list');
    var empty = document.getElementById('cart-empty');
    var footer = document.getElementById('cart-drawer-footer');
    if (!list) return;

    if (!this.items.length){
      list.innerHTML = '';
      if (empty) empty.style.display = 'block';
      if (footer) footer.style.display = 'none';
    } else {
      if (empty) empty.style.display = 'none';
      if (footer) footer.style.display = 'block';
      list.innerHTML = this.items.map(function(item){
        return `
          <div class="cart-item">
            <img class="cart-item__img" src="${item.image || ''}" alt="">
            <div>
              <a class="cart-item__title" href="${item.url}">${escapeHtml(item.product_title)}</a>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${escapeHtml(item.variant_title)}</div>` : ''}
              <div class="cart-item__actions">
                <div class="qty-control">
                  <button class="qty-btn" type="button" onclick="DojoCart.change('${item.key}',${item.quantity - 1})">−</button>
                  <span class="qty-display">${item.quantity}</span>
                  <button class="qty-btn" type="button" onclick="DojoCart.change('${item.key}',${item.quantity + 1})">+</button>
                </div>
                <strong>${DojoCart.formatMoney(item.final_line_price, cart.currency)}</strong>
              </div>
              <button class="cart-item__remove" type="button" onclick="DojoCart.change('${item.key}',0)">Remove</button>
            </div>
          </div>`;
      }).join('');
    }

    var subtotal = document.getElementById('cart-subtotal-amount');
    if (subtotal) subtotal.textContent = this.formatMoney(cart.total_price, cart.currency);

    var bar = document.getElementById('cart-shipping-bar');
    var text = document.getElementById('cart-shipping-text');
    var fill = document.getElementById('cart-shipping-fill');
    if (bar){
      bar.style.display = 'block';
      if (text) text.textContent = window.bloomThemeSettings.freeShippingText || 'Free worldwide shipping';
      if (fill) fill.style.width = '100%';
    }

    var note = document.getElementById('bloom-cart-note');
    if (note && document.activeElement !== note) note.value = cart.note || '';
    updateBundleStatus(cart.item_count || 0);
    renderBloomCartSavings(cart);
    renderBloomCartPage(cart);
    loadCartCompareAtData(cart).then(function(){ renderBloomCartSavings(cart); renderBloomCartPage(cart); refreshSmartCartFeeds(cart); });
  },
  change: function(key, quantity){
    var updates = {};
    updates[key] = Math.max(0, quantity);
    fetch('/cart/update.js', {
      method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates: updates})
    }).then(function(r){ return r.json(); }).then(function(cart){
      DojoCart.items = cart.items || [];
      DojoCart.total = cart.total_price || 0;
      DojoCart.render(cart);
    });
  }
};

function escapeHtml(value){ var div = document.createElement('div'); div.textContent = value || ''; return div.innerHTML; }
function openCartDrawer(){ var drawer=document.getElementById('cart-drawer'), overlay=document.getElementById('cart-overlay'); if(drawer)drawer.classList.add('open'); if(overlay)overlay.classList.add('open'); document.body.classList.add('is-locked'); DojoCart.fetchCart(); }
function closeCartDrawer(){ var drawer=document.getElementById('cart-drawer'), overlay=document.getElementById('cart-overlay'); if(drawer)drawer.classList.remove('open'); if(overlay)overlay.classList.remove('open'); document.body.classList.remove('is-locked'); }
function addToCart(variantId, quantity, title, callback, sellingPlan){ var payload={id:Number(variantId), quantity:Number(quantity)||1}; if(sellingPlan)payload.selling_plan=Number(sellingPlan); fetch('/cart/add.js',{method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)}).then(function(r){ if(!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'Unable to add item');}); return r.json(); }).then(function(){ DojoCart.fetchCart(); openCartDrawer(); showToast('Added to basket ✓'); if(callback)callback(); }).catch(function(err){ showToast(err.message || 'Please try again'); }); }
function quickAddToCart(event, variantId, title){ event.preventDefault(); event.stopPropagation(); addToCart(variantId, 1, title); }
function showToast(message){ var toast=document.getElementById('toast'), text=document.getElementById('toast-text'); if(!toast)return; if(text)text.textContent=message; toast.classList.add('show'); clearTimeout(window.dojoToastTimer); window.dojoToastTimer=setTimeout(function(){ toast.classList.remove('show'); },1200); }
function dojoToggleMenu(){ var menu=document.getElementById('dojo-mobile-nav'), button=document.querySelector('.dojo-menu-toggle'); if(!menu)return; var open=!menu.classList.contains('is-open'); menu.classList.toggle('is-open',open); menu.setAttribute('aria-hidden',String(!open)); if(button)button.setAttribute('aria-expanded',String(open)); document.body.classList.toggle('is-locked',open); }
function dojoToggleSearch(){ var search=document.getElementById('dojo-search'); if(!search)return; var open=!search.classList.contains('is-open'); search.classList.toggle('is-open',open); search.setAttribute('aria-hidden',String(!open)); document.body.classList.toggle('is-locked',open); if(open){ var input=search.querySelector('input'); setTimeout(function(){ if(input)input.focus(); },100); } }
function dojoActivateGalleryMedia(slide, active){
  if(!slide)return;
  var video=slide.querySelector('video');
  if(video){
    video.muted=true; video.loop=true; video.playsInline=true;
    if(active){ var promise=video.play(); if(promise && promise.catch)promise.catch(function(){}); }
    else { video.pause(); }
  }
  var iframe=slide.querySelector('iframe');
  if(iframe){
    if(!iframe.dataset.bloomBaseSrc)iframe.dataset.bloomBaseSrc=iframe.getAttribute('src')||'';
    var base=iframe.dataset.bloomBaseSrc;
    if(active && base){
      try{ var url=new URL(base,window.location.origin); url.searchParams.set('autoplay','1'); url.searchParams.set('mute','1'); url.searchParams.set('muted','1'); iframe.setAttribute('src',url.toString()); }catch(e){}
    }else if(!active && base && iframe.getAttribute('src')!==base){ iframe.setAttribute('src',base); }
  }
}
function dojoShowGallery(index){
  var slides=document.querySelectorAll('[data-dojo-gallery-slide]');
  var thumbs=document.querySelectorAll('[data-dojo-gallery-thumb]');
  if(!slides.length)return;
  var max=slides.length-1; if(index<0)index=max; if(index>max)index=0;
  window.dojoGalleryIndex=index;
  slides.forEach(function(el,i){ var active=i===index; el.classList.toggle('is-active',active); dojoActivateGalleryMedia(el,active); });
  thumbs.forEach(function(el,i){ el.classList.toggle('is-active',i===index); if(i===index && el.scrollIntoView)el.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'}); });
}
function dojoGalleryStep(delta){ var current=typeof window.dojoGalleryIndex==='number'?window.dojoGalleryIndex:0; dojoShowGallery(current+delta); }
function dojoSyncStickyProductBar(variant){
  var bar=document.querySelector('[data-ss-mobile-sticky-buy]');
  if(!bar || !variant)return;
  var variantLabel=bar.querySelector('[data-ss-sticky-variant]');
  var priceLabel=bar.querySelector('[data-ss-sticky-price]');
  var stickyButton=bar.querySelector('[data-ss-sticky-add]');
  var currency=window.dojoProductCurrency||'USD';
  if(variantLabel)variantLabel.textContent=variant.title==='Default Title'?'SheSelects Atelier':variant.title;
  if(priceLabel){
    var priceText=DojoCart.formatMoney(variant.price,currency);
    if(currency==='CAD'||currency==='AUD')priceText+=' '+currency;
    priceLabel.textContent=priceText;
  }
  if(stickyButton){
    stickyButton.disabled=!variant.available;
    stickyButton.textContent=variant.available?'Add to Cart':'Sold Out';
  }
}
function dojoUpdateProductVariant(form){
  if(!form || !window.dojoProductVariants)return;
  var selected=[];
  form.querySelectorAll('[data-dojo-option]:checked').forEach(function(input){ selected[Number(input.dataset.optionIndex)] = input.value; });
  var variant=window.dojoProductVariants.find(function(v){ return v.options.every(function(option,i){ return option===selected[i]; }); });
  if(!variant)return;
  var id=form.querySelector('[name="id"]');
  if(id)id.value=variant.id;
  var price=document.querySelector('[data-dojo-product-price]');
  if(price){
    price.innerHTML='<span>'+DojoCart.formatMoney(variant.price,window.dojoProductCurrency)+'</span>';
  }
  var add=form.querySelector('[name="add"]');
  if(add){
    add.disabled=!variant.available;
    add.textContent=variant.available?(add.dataset.availableText||'Add to Cart'):(add.dataset.soldText||'Sold Out');
  }
  dojoSyncStickyProductBar(variant);
  if(variant.featured_media && variant.featured_media.position)dojoShowGallery(variant.featured_media.position-1);
  var url=new URL(window.location.href);
  url.searchParams.set('variant',variant.id);
  window.history.replaceState({},'',url);
}
function setupMobileStickyBuy(form){
  var bar=document.querySelector('[data-ss-mobile-sticky-buy]');
  var mainButton=form && form.querySelector('[data-dojo-main-add]');
  var stickyButton=bar && bar.querySelector('[data-ss-sticky-add]');
  if(!bar || !mainButton || !stickyButton)return;
  var mediaQuery=window.matchMedia('(max-width: 749px)');
  var ticking=false;
  function updateVisibility(){
    ticking=false;
    var rect=mainButton.getBoundingClientRect();
    var mainButtonVisible=rect.top<window.innerHeight && rect.bottom>0;
    var shouldShow=mediaQuery.matches && window.scrollY>180 && !mainButtonVisible;
    bar.classList.toggle('is-visible',shouldShow);
    bar.setAttribute('aria-hidden',shouldShow?'false':'true');
    document.body.classList.toggle('ss-sticky-buy-visible',shouldShow);
  }
  function scheduleVisibility(){
    if(ticking)return;
    ticking=true;
    window.requestAnimationFrame(updateVisibility);
  }
  stickyButton.addEventListener('click',function(){
    if(!mainButton.disabled)mainButton.click();
  });
  window.addEventListener('scroll',scheduleVisibility,{passive:true});
  window.addEventListener('resize',scheduleVisibility,{passive:true});
  if(mediaQuery.addEventListener)mediaQuery.addEventListener('change',scheduleVisibility);
  var currentId=Number((form.querySelector('[name="id"]')||{}).value);
  var currentVariant=(window.dojoProductVariants||[]).find(function(variant){ return Number(variant.id)===currentId; });
  if(currentVariant)dojoSyncStickyProductBar(currentVariant);
  scheduleVisibility();
}
function saveCartNote(){ var field=document.getElementById('bloom-cart-note'); if(!field)return; fetch('/cart/update.js',{method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({note: field.value || ''})}).then(function(r){ return r.json(); }).then(function(cart){ showToast('Your note was saved'); DojoCart.render(cart); }).catch(function(){ showToast('We could not save the note. Please try again.'); }); }
function updateBundleStatus(itemCount){ var box=document.getElementById('bloom-offer-status'); if(!box || !window.bloomThemeSettings.bundleEnabled)return; var discount=window.bloomThemeSettings.bundleTwo||10; if(itemCount>=2){ box.textContent='Choose two, save '+discount+'% · Shopify applies the automatic offer in the basket or at checkout.'; } else if(itemCount===1){ box.textContent='Add one more eligible bag to unlock '+discount+'% off.'; } else { box.textContent='Choose any two eligible bags and save '+discount+'%.'; } }
function setupProductCardForms(){
  document.querySelectorAll('[data-card-toggle]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      var card=btn.closest('.product-card'); if(!card)return;
      var panel=card.querySelector('.product-card__quick-panel'); if(!panel)return;
      var willOpen = panel.hasAttribute('hidden');
      document.querySelectorAll('.product-card__quick-panel').forEach(function(p){ if(p!==panel)p.setAttribute('hidden','hidden'); });
      document.querySelectorAll('[data-card-toggle]').forEach(function(other){ if(other!==btn)other.setAttribute('aria-expanded','false'); });
      if(willOpen){ panel.removeAttribute('hidden'); btn.setAttribute('aria-expanded','true'); }
      else { panel.setAttribute('hidden','hidden'); btn.setAttribute('aria-expanded','false'); }
    });
  });

  document.querySelectorAll('[data-card-form]').forEach(function(form){
    var dataTag=form.querySelector('.product-card__variants-data');
    var variants=[];
    try { variants=JSON.parse(dataTag.textContent || '[]'); } catch(e){}
    function update(){
      var selected=[];
      form.querySelectorAll('[data-card-option]').forEach(function(select){ selected[Number(select.dataset.optionIndex)] = select.value; });
      var variant=variants.find(function(v){ return v.options.every(function(option,i){ return !selected[i] || option===selected[i]; }); }) || variants[0];
      var id=form.querySelector('[name="id"]');
      if(id && variant) id.value = variant.id;
      var submit=form.querySelector('.product-card__panel-submit');
      if(submit && variant){ submit.disabled=!variant.available; submit.textContent = variant.available ? 'Add to cart' : 'Sold out'; }
    }
    form.querySelectorAll('[data-card-option]').forEach(function(select){ select.addEventListener('change', update); });
    update();
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var id=form.querySelector('[name="id"]');
      if(!id || !id.value)return;
      addToCart(id.value,1,form.dataset.productTitle || 'Item',function(){
        var panel=form.closest('.product-card__quick-panel'); if(panel)panel.setAttribute('hidden','hidden');
        var btn=form.closest('.product-card').querySelector('[data-card-toggle]'); if(btn)btn.setAttribute('aria-expanded','false');
      });
    });
  });
}
function bloomShuffle(items){
  var copy=items.slice();
  for(var i=copy.length-1;i>0;i--){ var j=Math.floor(Math.random()*(i+1)); var t=copy[i]; copy[i]=copy[j]; copy[j]=t; }
  return copy;
}
function bloomPriceToCents(value){
  if(value===null || typeof value==='undefined' || value==='')return 0;
  if(typeof value==='number')return Number.isInteger(value) && value>999 ? value : Math.round(value*100);
  var clean=String(value).replace(/[^0-9.,-]/g,'').replace(',','.');
  return Math.round((parseFloat(clean)||0)*100);
}
var BloomProductFeed={products:[],promise:null,used:{},page:0,exhausted:false,requestPage:function(page){
  var self=this;
  function request(url){return fetch(url,{headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw new Error('feed');return r.json();});}
  return request('/products.json?limit=250&page='+page).catch(function(){return request('/collections/all/products.json?limit=250&page='+page);}).then(function(data){
    var incoming=(data.products||[]).filter(function(p){return p&&p.variants&&p.variants.length;});
    var known={};self.products.forEach(function(p){known[String(p.id)]=true;});incoming.forEach(function(p){if(!known[String(p.id)])self.products.push(p);});
    self.page=page;if(incoming.length<250)self.exhausted=true;return self.products;
  }).catch(function(){self.exhausted=true;return self.products;});
},load:function(){
  if(this.products.length)return Promise.resolve(this.products);if(this.promise)return this.promise;var self=this;this.promise=this.requestPage(1).then(function(products){self.promise=null;return products;});return this.promise;
},loadNext:function(){if(this.exhausted)return Promise.resolve(this.products);if(this.promise)return this.promise;var self=this;this.promise=this.requestPage(this.page+1).then(function(products){self.promise=null;return products;});return this.promise;}};
function bloomProductOptions(product){
  if(Array.isArray(product.options) && product.options.length && typeof product.options[0]==='object')return product.options;
  var names=Array.isArray(product.options)?product.options:[];
  return names.map(function(name,index){ var key='option'+(index+1), values=[]; (product.variants||[]).forEach(function(v){if(v[key] && values.indexOf(v[key])<0)values.push(v[key]);}); return {name:name,values:values}; });
}
function bloomVariantOptions(variant){ return variant.options || [variant.option1,variant.option2,variant.option3].filter(Boolean); }
function bloomFeedCard(product){
  var variants=(product.variants||[]), first=variants.find(function(v){return v.available!==false;})||variants[0];
  var image=''; if(product.images && product.images.length){ var img=product.images[0]; image=typeof img==='string'?img:(img.src||''); } if(!image && product.image)image=typeof product.image==='string'?product.image:(product.image.src||'');
  var options=bloomProductOptions(product).slice(0,3);
  var selects=options.map(function(option,index){ var values=option.values||[]; return '<label><span>'+escapeHtml(option.name||('Option '+(index+1)))+'</span><select data-feed-option data-option-index="'+index+'">'+values.map(function(value){return '<option value="'+escapeHtml(String(value))+'">'+escapeHtml(String(value))+'</option>';}).join('')+'</select></label>'; }).join('');
  var price=bloomPriceToCents(first && first.price), currency=(window.dojoProductCurrency||'USD');
  var priceHtml='<strong data-feed-price>'+DojoCart.formatMoney(price,currency)+'</strong>';
  return '<article class="bloom-feed-card" data-feed-product-id="'+product.id+'"><a class="bloom-feed-card__image" href="/products/'+encodeURIComponent(product.handle)+'">'+(image?'<img src="'+image+'" alt="'+escapeHtml(product.title)+'">':'<span>♥</span>')+'</a><a class="bloom-feed-card__title" href="/products/'+encodeURIComponent(product.handle)+'">'+escapeHtml(product.title)+'</a><div class="bloom-feed-card__price">'+priceHtml+'</div><form data-feed-form data-product-title="'+escapeHtml(product.title)+'"><input type="hidden" name="id" value="'+(first?first.id:'')+'">'+selects+'<script type="application/json" data-feed-variants>'+JSON.stringify(variants).replace(/</g,'\\u003c')+'<\/script><button type="submit">Add to cart</button></form></article>';
}
function bindBloomFeedCards(root){
  root.querySelectorAll('[data-feed-form]:not([data-bound])').forEach(function(form){
    form.dataset.bound='true'; var tag=form.querySelector('[data-feed-variants]'), variants=[]; try{variants=JSON.parse(tag.textContent||'[]');}catch(e){}
    function update(){ var selected=[]; form.querySelectorAll('[data-feed-option]').forEach(function(s){selected[Number(s.dataset.optionIndex)]=s.value;}); var variant=variants.find(function(v){var opts=bloomVariantOptions(v);return opts.every(function(value,i){return !selected[i]||String(value)===String(selected[i]);});})||variants[0]; if(!variant)return; form.querySelector('[name="id"]').value=variant.id; var button=form.querySelector('button[type="submit"]'); button.disabled=variant.available===false; button.textContent=variant.available===false?'Sold out':'Add to cart'; var card=form.closest('.bloom-feed-card'), price=card.querySelector('[data-feed-price]'), p=bloomPriceToCents(variant.price), currency=window.dojoProductCurrency||'USD'; if(price)price.textContent=DojoCart.formatMoney(p,currency); }
    form.querySelectorAll('[data-feed-option]').forEach(function(s){s.addEventListener('change',update);}); update();
    form.addEventListener('submit',function(e){e.preventDefault();var id=form.querySelector('[name="id"]');if(id&&id.value)addToCart(id.value,1,form.dataset.productTitle||'Item');});
  });
}
function bloomExistingProductIds(container){ var ids={}; container.querySelectorAll('[data-product-id],[data-feed-product-id]').forEach(function(el){var id=el.getAttribute('data-product-id')||el.getAttribute('data-feed-product-id');if(id)ids[String(id)]=true;}); return ids; }
function bloomAppendFeedProducts(container,count,excludeIds,context){
  var key=context||container.dataset.feedContext||'feed';
  function choose(products,allowExisting){
    var used=BloomProductFeed.used[key]||(BloomProductFeed.used[key]={}),existing=bloomExistingProductIds(container),cartIds={};(DojoCart.items||[]).forEach(function(item){cartIds[String(item.product_id)]=true;});
    var filtered=products.filter(function(p){return (allowExisting||!existing[String(p.id)])&&!used[String(p.id)]&&!cartIds[String(p.id)]&&!(excludeIds&&excludeIds[String(p.id)]);});
    var prefs=container._bloomPrefs||null;
    if(!prefs)return bloomShuffle(filtered);
    return filtered.map(function(product){return {product:product,score:bloomRecommendationScore(product,prefs),random:Math.random()};}).sort(function(a,b){return b.score-a.score||a.random-b.random;}).map(function(row){return row.product;});
  }
  return BloomProductFeed.load().then(function(products){
    var candidates=choose(products,false);
    if(candidates.length<count&&!BloomProductFeed.exhausted)return BloomProductFeed.loadNext().then(function(more){return choose(more,false);});
    return candidates;
  }).then(function(candidates){
    if(candidates.length<count&&BloomProductFeed.exhausted){BloomProductFeed.used[key]={};candidates=choose(BloomProductFeed.products,false);if(!candidates.length)candidates=choose(BloomProductFeed.products,true);}
    var used=BloomProductFeed.used[key]||(BloomProductFeed.used[key]={}),chosen=candidates.slice(0,count);chosen.forEach(function(product){used[String(product.id)]=true;container.insertAdjacentHTML('beforeend',bloomFeedCard(product));});bindBloomFeedCards(container);return chosen.length;
  });
}
function setupDynamicFeeds(){
  document.querySelectorAll('[data-bloom-feed]').forEach(function(container){
    if(container.dataset.feedReady)return;
    container.dataset.feedReady='true';
    var initial=Number(container.dataset.feedInitial||3), step=Number(container.dataset.feedStep||3), context=container.dataset.feedContext||'feed';
    var scope=container.closest('.dojo-cart-upsell,.bloom-cart-page__recommendations,.dojo-section')||container.parentElement;
    var button=scope&&scope.querySelector('[data-bloom-feed-more]');
    if(button)button.addEventListener('click',function(){button.disabled=true;bloomAppendFeedProducts(container,step,{},context).finally(function(){button.disabled=false;});});
    if(!container.hasAttribute('data-smart-cart-feed'))bloomAppendFeedProducts(container,initial,{},context);
  });
}
function setupRandomGrids(){
  document.querySelectorAll('[data-random-grid]').forEach(function(grid){
    var items=Array.prototype.slice.call(grid.querySelectorAll('[data-grid-item]')); if(!grid.hasAttribute('data-smart-grid'))bloomShuffle(items).forEach(function(item){grid.appendChild(item);});
    var button=grid.parentElement.querySelector('[data-load-more-grid]'), step=Number(button&&button.dataset.step||grid.dataset.feedStep||6), exclude={}; if(grid.dataset.excludeProductId)exclude[String(grid.dataset.excludeProductId)]=true;
    if(button)button.addEventListener('click',function(){
      var hidden=Array.prototype.slice.call(grid.querySelectorAll('[data-grid-item][hidden]')), reveal=hidden.slice(0,step); reveal.forEach(function(item){item.removeAttribute('hidden');});
      var remaining=step-reveal.length; if(remaining>0){button.disabled=true;bloomAppendFeedProducts(grid,remaining,exclude,grid.dataset.feedContext||'product-recommendations').finally(function(){button.disabled=false;});}
    });
  });
}



function bloomSocialCategory(product){
  var text=((product.title||'')+' '+((product.tags||[]).join(' '))).toLowerCase();
  if(/cardigan|sweater|knit|pullover/.test(text))return 'knit';
  if(/romper|onesie|bodysuit/.test(text))return 'romper';
  if(/dress|gown/.test(text))return 'dress';
  if(/personal|custom|blanket|bonnet|hat/.test(text))return 'personalized';
  if(/set|gift|bundle/.test(text))return 'set';
  return 'other';
}
function setupRandomSocialGallery(){
  document.querySelectorAll('[data-random-social-gallery]').forEach(function(section){
    if(section.dataset.socialReady)return;
    section.dataset.socialReady='true';
    var dataTag=section.querySelector('[data-social-candidates]');
    var candidates=[];
    try{candidates=JSON.parse(dataTag.textContent||'[]');}catch(e){}
    if(!candidates.length)return;
    var shuffled=bloomShuffle(candidates);
    var selected=[], usedIds={}, usedCategories={};
    shuffled.forEach(function(product){
      var category=bloomSocialCategory(product);
      if(selected.length<6 && !usedCategories[category]){
        selected.push(product); usedIds[String(product.id)]=true; usedCategories[category]=true;
      }
    });
    shuffled.forEach(function(product){
      if(selected.length<6 && !usedIds[String(product.id)]){
        selected.push(product); usedIds[String(product.id)]=true;
      }
    });
    section.querySelectorAll('[data-social-tile]').forEach(function(tile,index){
      var product=selected[index]; if(!product)return;
      tile.setAttribute('href',product.url||'#');
      tile.innerHTML='<img src="'+product.image+'" alt="'+escapeHtml(product.title||'BloomKnit baby outfit')+'" loading="lazy">';
    });
  });
}


function setupHomeProductGrid(){
  document.querySelectorAll('[data-home-products]').forEach(function(grid){
    if(grid.dataset.homeReady==='true')return;
    grid.dataset.homeReady='true';
    var items=Array.prototype.slice.call(grid.querySelectorAll('[data-home-product]'));
    if(!items.length)return;
    items=bloomShuffle(items);
    items.forEach(function(item){grid.appendChild(item);});
    var initial=Math.max(1,Number(grid.dataset.initial||8));
    var step=Math.max(1,Number(grid.dataset.step||4));
    var visible=initial;
    function update(){
      items.forEach(function(item,index){
        if(index<visible)item.removeAttribute('hidden');
        else item.setAttribute('hidden','hidden');
      });
      var scope=grid.closest('.dojo-section')||grid.parentElement;
      var button=scope&&scope.querySelector('[data-home-more]');
      if(button)button.hidden=visible>=items.length;
    }
    var scope=grid.closest('.dojo-section')||grid.parentElement;
    var button=scope&&scope.querySelector('[data-home-more]');
    if(button)button.addEventListener('click',function(){visible=Math.min(items.length,visible+step);update();});
    update();
  });
}


function bloomNormalizeWords(value){
  return String(value||'').toLowerCase().replace(/[^a-z0-9\s-]/g,' ').split(/\s+/).filter(function(word){return word.length>2;});
}
function bloomRecommendationPreferences(cart){
  var prefs={types:{},tags:{},words:{}};
  (cart.items||[]).forEach(function(item){
    var detail=item.handle&&BloomProductDetailCache[item.handle]?BloomProductDetailCache[item.handle]:null;
    var type=(detail&&(detail.type||detail.product_type))||item.product_type||'';
    if(type)prefs.types[String(type).toLowerCase()]=true;
    var tags=detail&&detail.tags?detail.tags:[];
    if(typeof tags==='string')tags=tags.split(',');
    (tags||[]).forEach(function(tag){var clean=String(tag).trim().toLowerCase();if(clean&&['sale','new','featured','bestseller'].indexOf(clean)<0)prefs.tags[clean]=true;});
    bloomNormalizeWords((detail&&detail.title)||item.product_title).forEach(function(word){prefs.words[word]=true;});
  });
  return prefs;
}
function bloomRecommendationScore(product,prefs){
  if(!prefs)return 0;
  var score=0,type=String(product.product_type||product.type||'').toLowerCase();
  if(type&&prefs.types[type])score+=100;
  var tags=product.tags||[];if(typeof tags==='string')tags=tags.split(',');
  (tags||[]).forEach(function(tag){if(prefs.tags[String(tag).trim().toLowerCase()])score+=18;});
  bloomNormalizeWords(product.title).forEach(function(word){if(prefs.words[word])score+=4;});
  return score;
}
function refreshSmartCartFeeds(cart){
  var containers=document.querySelectorAll('[data-smart-cart-feed]');
  if(!containers.length)return;
  var signature=(cart.items||[]).map(function(item){return String(item.product_id);}).sort().join('|');
  var prefs=bloomRecommendationPreferences(cart);
  containers.forEach(function(container){
    if(container.dataset.cartSignature===signature&&container.children.length)return;
    container.dataset.cartSignature=signature;
    container._bloomPrefs=prefs;
    container.innerHTML='';
    var context=container.dataset.feedContext||'cart-smart';
    BloomProductFeed.used[context]={};
    bloomAppendFeedProducts(container,Number(container.dataset.feedInitial||3),{},context);
  });
}

function bloomCartCurrency(cart){ return cart.currency || window.dojoProductCurrency || 'USD'; }
var BloomProductDetailCache={};
function loadCartCompareAtData(cart){
  cart._bloomRegularTotal=Number(cart.original_total_price||cart.total_price||0);
  return Promise.resolve(cart);
}
function bloomCartMetrics(cart){
  var saleSubtotal=Number(cart.original_total_price||0); if(!saleSubtotal && cart.items)saleSubtotal=cart.items.reduce(function(sum,item){return sum+Number(item.original_line_price||item.final_line_price||0);},0);
  var regular=Number(cart._bloomRegularTotal||saleSubtotal), basketTotal=Number(cart.total_price||saleSubtotal), bundleSaving=Number(cart.total_discount||Math.max(0,saleSubtotal-basketTotal)), saleSaving=Math.max(0,regular-saleSubtotal), count=Number(cart.item_count||0), two=Number(window.bloomThemeSettings&&window.bloomThemeSettings.bundleTwo||10), three=Number(window.bloomThemeSettings&&window.bloomThemeSettings.bundleTwo||10);
  return {regular:regular,saleSubtotal:saleSubtotal,saleSaving:saleSaving,bundleSaving:bundleSaving,totalSaving:saleSaving+bundleSaving,basketTotal:basketTotal,count:count,two:two,three:three};
}
function bloomRewardCopy(m){
  if(m.count<=0)return {title:'Choose two, save '+m.two+'%',message:'Add any two eligible bags to unlock the automatic offer.',badge:m.two+'%',progress:0};
  if(m.count===1)return {title:'One more bag',message:'Add 1 more eligible bag to unlock '+m.two+'% off.',badge:'Next '+m.two+'%',progress:50};
  return {title:'Choose two, save '+m.two+'%',message:m.bundleSaving>0?m.two+'% savings are included in your basket total.':'Your basket qualifies for the '+m.two+'% offer. Shopify confirms the automatic discount in the basket or at checkout.',badge:m.two+'%',progress:100};
}
function setText(id,value){var el=document.getElementById(id);if(el)el.textContent=value;}
function setWidth(id,value){var el=document.getElementById(id);if(el)el.style.width=value+'%';}
function toggleRow(id,show){var el=document.getElementById(id);if(el)el.hidden=!show;}
function renderBloomCartSavings(cart){
  DojoCart.currentCart=cart; var m=bloomCartMetrics(cart),copy=bloomRewardCopy(m),currency=bloomCartCurrency(cart),format=function(v){return DojoCart.formatMoney(v,currency);};
  var reward=document.getElementById('bloom-cart-rewards');if(reward)reward.style.display=m.count?'block':'none';
  setText('bloom-reward-title',copy.title);setText('bloom-reward-message',copy.message);setText('bloom-reward-badge',copy.badge);setWidth('bloom-tier-progress-fill',copy.progress);
  setText('bloom-drawer-regular-total',format(m.regular));setText('bloom-drawer-sale-saving','−'+format(m.saleSaving));setText('bloom-drawer-bundle-saving','−'+format(m.bundleSaving));setText('bloom-drawer-basket-total',format(m.basketTotal));toggleRow('bloom-drawer-sale-row',m.saleSaving>0);toggleRow('bloom-drawer-bundle-row',m.bundleSaving>0);
  setText('bloom-reward-note',m.bundleSaving>0?'The automatic 10% multi-bag offer is already applied.':'Choose any two eligible bags and Shopify will apply the 10% offer in the basket or at checkout.');
  var savingBox=document.getElementById('cart-total-saving');if(savingBox){savingBox.hidden=!(m.totalSaving>0);setText('cart-total-saving-amount','−'+format(m.totalSaving));}setText('cart-subtotal-amount',format(m.basketTotal));
}
function renderBloomCartPage(cart){
  var root=document.querySelector('[data-bloom-cart-page]');if(!root)return;var m=bloomCartMetrics(cart),copy=bloomRewardCopy(m),currency=bloomCartCurrency(cart),format=function(v){return DojoCart.formatMoney(v,currency);},empty=document.getElementById('bloom-cart-page-empty'),content=document.getElementById('bloom-cart-page-content');if(empty)empty.hidden=m.count>0;if(content)content.hidden=m.count===0;setText('bloom-cart-page-count',m.count);
  var list=document.getElementById('bloom-cart-page-items');if(list&&cart.items){list.innerHTML=cart.items.map(function(item){var variant=item.variant_title&&item.variant_title!=='Default Title'?'<p class="bloom-cart-page__variant">'+escapeHtml(item.variant_title)+'</p>':'',properties='';if(item.properties)Object.keys(item.properties).forEach(function(key){if(key.charAt(0)!=='_'&&item.properties[key])properties+='<p class="bloom-cart-page__property">'+escapeHtml(key)+': '+escapeHtml(String(item.properties[key]))+'</p>';});var oldPrice=Number(item.original_line_price||0)>Number(item.final_line_price||0)?'<s>'+format(item.original_line_price)+'</s>':'';return '<article class="bloom-cart-page__item" data-cart-key="'+escapeHtml(item.key)+'"><a class="bloom-cart-page__image" href="'+item.url+'"><img src="'+(item.image||'')+'" alt=""></a><div class="bloom-cart-page__item-info"><a class="bloom-cart-page__item-title" href="'+item.url+'">'+escapeHtml(item.product_title)+'</a>'+variant+properties+'<div class="bloom-cart-page__item-bottom"><div class="qty-control bloom-cart-page__qty"><button type="button" onclick="DojoCart.change(\''+item.key+'\','+(item.quantity-1)+')">−</button><span>'+item.quantity+'</span><button type="button" onclick="DojoCart.change(\''+item.key+'\','+(item.quantity+1)+')">+</button></div><div class="bloom-cart-page__line-price">'+oldPrice+'<strong>'+format(item.final_line_price)+'</strong></div></div><button class="bloom-cart-page__remove" type="button" onclick="DojoCart.change(\''+item.key+'\',0)">Remove</button></div></article>';}).join('');}
  setText('bloom-page-reward-title',copy.title);setText('bloom-page-reward-message',copy.message);setText('bloom-page-reward-badge',copy.badge);setWidth('bloom-page-tier-progress-fill',copy.progress);
  setText('bloom-page-regular-total',format(m.regular));setText('bloom-page-sale-saving','−'+format(m.saleSaving));setText('bloom-page-bundle-saving','−'+format(m.bundleSaving));setText('bloom-page-basket-total',format(m.basketTotal));setText('bloom-page-saved-amount','−'+format(m.totalSaving));toggleRow('bloom-page-sale-row',m.saleSaving>0);toggleRow('bloom-page-bundle-row',m.bundleSaving>0);var saved=document.getElementById('bloom-page-saved-box');if(saved)saved.hidden=!(m.totalSaving>0);
  setText('bloom-page-reward-note',m.bundleSaving>0?'The Shopify automatic 10% offer is included above.':'Choose any two eligible bags and Shopify will apply the 10% offer in the basket or at checkout.');var note=document.getElementById('bloom-cart-page-note');if(note&&document.activeElement!==note)note.value=cart.note||'';var hidden=document.getElementById('bloom-cart-page-note-hidden');if(hidden)hidden.value=cart.note||'';
}
function saveCartPageNote(){var field=document.getElementById('bloom-cart-page-note');if(!field)return;fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:field.value||''})}).then(function(r){return r.json();}).then(function(cart){DojoCart.items=cart.items||[];DojoCart.total=cart.total_price||0;DojoCart.render(cart);showToast('Your gift note was saved');}).catch(function(){showToast('We could not save the note. Please try again.');});}

document.addEventListener('DOMContentLoaded',function(){
  window.bloomThemeSettings={
    freeShippingText: document.body.dataset.freeShipping || 'Free worldwide shipping',
    bundleEnabled: document.body.dataset.bundleEnabled === 'true',
    bundleTwo: Number(document.body.dataset.bundleTwo || 10),
    bundleThree: Number(document.body.dataset.bundleTwo || 10)
  };
  DojoCart.init();
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'){
      closeCartDrawer();
      var search=document.getElementById('dojo-search'); if(search && search.classList.contains('is-open')) dojoToggleSearch();
      var menu=document.getElementById('dojo-mobile-nav'); if(menu && menu.classList.contains('is-open')) dojoToggleMenu();
    }
  });
  document.querySelectorAll('[data-dojo-product-form]').forEach(function(form){
    form.addEventListener('change',function(e){ if(e.target.matches('[data-dojo-option]')) dojoUpdateProductVariant(form); });
    var addButton=form.querySelector('[name="add"]');
    if(addButton) addButton.addEventListener('click',function(e){
      e.preventDefault();
      var id=form.querySelector('[name="id"]').value;
      var qty=form.querySelector('[name="quantity"]');
      var sellingPlan=form.querySelector('[name="selling_plan"]:checked');
      addToCart(id, qty ? qty.value : 1, form.dataset.productTitle, null, sellingPlan ? sellingPlan.value : '');
    });
    setupMobileStickyBuy(form);
  });
  setupProductCardForms();
  setupDynamicFeeds();
  setupRandomGrids();
  setupHomeProductGrid();
  setupRandomSocialGallery();
  dojoShowGallery(0);
});
